// extracted by mini-css-extract-plugin
module.exports = {"metadata":"ImageCard-Metadata--metadata--cUVQO","label":"ImageCard-Metadata--label--3y9pk"};